import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import _ from 'lodash';
import { LoadingService } from '../service/loading.service';
import { VendorInformationChangeRequestService } from '../service/vendor-information-change-request.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotificationService } from '../service/notification.service';
import { InvoiceHistoryComponent } from '../reports/invoice-history/invoice-history.component';
import { InformationChangeRequestComponent } from '../forms/information-change-request/information-change-request.component';
import { PurchaseOrderHistoryComponent } from '../reports/purchase-order-history/purchase-order-history.component';
import { VendorFormService } from '../service/vendor.service';
import { UtilityService } from '../service/utility.service';
import { isRestrictedMode } from '../auth/restricted-mode';
import { SessionService } from '../service/session.service';
import {
  PortalFeatureDirective,
  PortalLoginRequiredDirective,
  PortalButtonDirective,
} from '../directives';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [
    CommonModule,
    InvoiceHistoryComponent,
    InformationChangeRequestComponent,
    PurchaseOrderHistoryComponent,
    PortalFeatureDirective,
    PortalLoginRequiredDirective,
    PortalButtonDirective,
  ],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit {
  Name: string;
  Vendorid: string;
  vendorNumber: string;
  Email: string;
  Address: string;
  Status: string;
  readonly isRestricted = isRestrictedMode();
  form: FormGroup;
  formopen = 0; // Use formopen to track the active component
  userName: string = 'Emily Hannah';
  CompletionDate: any;
  prefixLabel: string = '';
  readonly clientId!: string;

  constructor(
    private router: Router,
    private spinner: LoadingService,
    private VendorInformationChangeRequestService: VendorInformationChangeRequestService,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private vendorFormService: VendorFormService,
    private utilityService: UtilityService,
    private sessionService: SessionService,
  ) {
    this.form = this.formBuilder.group({
      VendorId: ['00000000-0000-0000-0000-000000000000'],
    });
  }

  ngOnInit(): void {
    this.vendorNumber = JSON.parse(localStorage.getItem('vendorNumber') || '');
    const lastFormOpen = sessionStorage.getItem('formopen');
    if (lastFormOpen) {
      sessionStorage.removeItem('formopen');
      this.formopen = 0;
    }

    const vendorId = JSON.parse(localStorage.getItem('vendorId') || 'null');
    this.form.get('VendorId')!.setValue(vendorId);

    const userEmail = JSON.parse(localStorage.getItem('userEmail') || '');
    this.vendorFormService.getForm(vendorId).subscribe(
      (data: any) => {
        this.spinner.OnLoading.emit(false);
        localStorage.setItem('registrationData', JSON.stringify(data));
        this.Name = data.name;
        this.Vendorid = data.id;
        this.Email = userEmail;
        this.Address = data.address;
        this.form.get('VendorId')!.setValue(data.id);
      },
      (err: any) => {
        this.spinner.OnLoading.emit(false);
        this.notificationService.showError(err, 'Error');
      },
    );
    this.getFormStatus();
  }

  openComponent(formIndex: number) {
    this.formopen = formIndex;
  }

  getFormStatus() {
    let request = _.cloneDeep(this.form.value);
    this.spinner.OnLoading.emit(true);
    this.VendorInformationChangeRequestService.getFormStatus(
      request,
      this.prefixLabel,
    ).subscribe(
      (data: any) => {
        this.spinner.OnLoading.emit(false);

        if (!data || !data.confirmation) {
          this.Status = 'No Request found';
          return;
        }

        const confirmation = data.confirmation;

        if (confirmation.startsWith('Vendor Change Request is Completed')) {
          this.Status = 'Your Request is Completed';

          const colonIndex = confirmation.indexOf(':');
          if (colonIndex !== -1 && confirmation.length > colonIndex + 1) {
            const datePart = confirmation.substring(colonIndex + 1).trim();
            this.CompletionDate = datePart;
          } else {
            this.CompletionDate = 'Unknown';
          }
        } else if (confirmation === 'Vendor Change Request is In Progress') {
          this.Status = 'Your Request is In progress';
          this.CompletionDate = null;
        } else if (
          confirmation === 'Vendor Change Request is Denied' ||
          confirmation.startsWith('Vendor Change Request is Denied:')
        ) {
          this.Status = 'Your Request was Denied';
          this.CompletionDate = null;
        } else if (confirmation === 'Vendor Change Request is Inactive') {
          this.Status = 'Your Request is Inactive';
          this.CompletionDate = null;
        } else if (confirmation === 'No Change request found') {
          this.Status = 'No Request found';
          this.CompletionDate = null;
        } else {
          this.Status = 'No Request found';
          this.CompletionDate = null;
        }
      },
      (err: any) => {
        this.spinner.OnLoading.emit(false);
        this.Status = 'No Request found';
        this.CompletionDate = null;
        this.notificationService.showError(err, 'Error');
      },
    );
  }

  logout() {
    this.sessionService.logout();
  }

  // Direct access to portal configuration
  get portalConfig() {
    return this.utilityService.portalConfig;
  }
}
